import React from "react"

export const CustomSelectErrorMessage = ({meta}) => {
    return meta?.touched && meta.error ? (
        <div className="custom-select-invalid-feedback">
            {meta.error}
        </div>
    ) : null
}